import React, { useEffect, useState } from 'react';
import { css } from 'twin.macro';
import dayjs from 'dayjs';
import { FaEye } from 'react-icons/fa';
import Avatar from '../../../../../Admin/reusableComponents/Avatar';
import { AddTagsTooltip, TagPreviewWithContainer } from '../../../../Common/Tags/TagsPreview';
import TagsModal from '../../../../Common/Tags/TagsModal';
import { ViewUserForm } from '../../../../../Admin/Form/SubmittedForm';
import FormContributionHistory from '../../../../../Admin/Form/FormContributionHistory';
import { MdHistoryToggleOff } from 'react-icons/md';

const UserFormDataRow = ({
    form: currentForm = {},
    currentPage,
    formCounter,
    i,
    setForm: setBulkForm,
    managerView,
    updateTagsInSubmittedForms,
}) => {
    const [showTagsModal, setShowTagsModal] = useState(false);
    const handleShowTagsModal = (id) => setShowTagsModal(id);
    const handleCloseTagsModal = () => setShowTagsModal(false);
    const [form, setForm] = useState(currentForm);

    useEffect(() => {
        setForm(currentForm);
    }, [currentForm]);
    const handleUpdateUserFormDataPreview = (updatedForm) => {
        if (!updatedForm) {
            return;
        }

        setForm((prevForm) => ({
            ...prevForm,
            ...updatedForm,
        }));
    };
    if (!form || !form._id) {
        return null;
    }
    return (
        <tr>
            <td>{(currentPage - 1) * 10 + (i + 1)} </td>
            <td
                css={css`
                    flex: 1;
                `}
            >
                <div
                    css={css`
                        display: flex;
                        flex-direction: column;
                        gap: 0.5rem;
                    `}
                >
                    <span className={`${form?.userData?.name ? '' : 'text-danger'} d-flex flex-row align-items-center`}>
                        <Avatar item={form?.userData} />
                        <span
                            className="d-flex flex-column"
                            css={css`
                                margin-left: 0.1rem;
                            `}
                        >
                            <div
                                css={css`
                                    display: flex;
                                `}
                            >
                                <span
                                    className="ml-1"
                                    css={css`
                                        font-size: 18px;
                                    `}
                                >
                                    {form?.userData?.name ? form?.userData?.name : 'Deleted User'}
                                </span>
                                {!managerView && (
                                    <span
                                        css={css`
                                            width: fit-content;
                                            cursor: pointer;
                                            margin-left: 10px;
                                        `}
                                        onClick={() => handleShowTagsModal(form._id || form.id)}
                                    >
                                        <AddTagsTooltip />
                                    </span>
                                )}
                                {showTagsModal === (form?._id || form?.id) ? (
                                    <TagsModal
                                        show={!!showTagsModal}
                                        handleClose={handleCloseTagsModal}
                                        type={'userform'}
                                        tagAction={'assign'}
                                        objectId={form?._id || form?.id}
                                        prevTags={form?.tags}
                                        responseCallback={updateTagsInSubmittedForms}
                                    />
                                ) : null}
                            </div>
                            <ViewUserForm id={form._id} form={form} handleUpdate={handleUpdateUserFormDataPreview}>
                                <span
                                    className="btn btn-link"
                                    css={css`
                                        font-size: 14px;
                                        padding: 0;
                                    `}
                                >
                                    <FaEye className="mr-1" />
                                    {form?.isStarred && <span className="mr-1">⭐</span>}
                                    {<span>View this submission</span>}
                                </span>
                            </ViewUserForm>
                            {form?.extraInfo?.history && form?.extraInfo?.history?.length && (
                                <FormContributionHistory id={form?._id || form?.id} form={form}>
                                    <span
                                        className="btn btn-link"
                                        css={css`
                                            font-size: 14px;
                                            padding: 0;
                                        `}
                                    >
                                        <MdHistoryToggleOff className="mr-3" />
                                        View Contribution
                                    </span>
                                </FormContributionHistory>
                            )}
                        </span>
                    </span>
                    <TagPreviewWithContainer tags={form?.tags || []} style={{ maxWidth: '50rem' }} />
                </div>
            </td>
            <td>
                <span className="d-flex flex-column">
                    <span
                        css={css`
                            font-weight: 600;
                            font-size: 16px;
                        `}
                    >
                        {form?.formData?.name}
                    </span>
                    <span
                        className="btn btn-link"
                        css={css`
                            font-size: 14px;
                            padding: 0;
                            text-align: left;
                        `}
                        onClick={() => setBulkForm(form.formData)}
                    >
                        <FaEye className="mr-3" />
                        View bulk submissions
                    </span>
                    <div className="d-flex flex-row align-items-center">
                        <span className="badge badge-primary">{form?.type || ''}</span>
                        <span className="ml-2 badge badge-secondary">{(form?.specialityForm || {})?.type || ''}</span>
                    </div>
                </span>
            </td>
            {managerView ? (
                <td
                    className={`${(form?.teamData || {})?.name ? '' : 'text-danger'} text-left`}
                    css={css`
                        max-width: 300px;
                    `}
                >
                    {(form?.teamData || {})?.name ? form?.teamData?.name : 'Team Deleted'}
                </td>
            ) : null}

            <td
                className={`${form?.chatroomData?.title ? '' : 'text-danger'} text-left`}
                css={css`
                    max-width: 300px;
                `}
            >
                {form?.chatroomData?.title ? form?.chatroomData?.title : 'Channel Deleted'}
            </td>
            <td>
                {form?.submissionType === 'draft' ? <span className="badge badge-warning">draft</span> : <span>-</span>}
            </td>
            <td>{dayjs(form?.createdAt).format('MMMM D, YYYY h:mm A')}</td>
        </tr>
    );
};

export default UserFormDataRow;
